export default function* homeSaga() {
  // yield takeLatest('CATEGORY_SET', categorySet);
}
